import { useNavigate } from "react-router-dom";
import useBrowseState from "../../hooks/useBrowseState";
import { shopPath } from "../../routes";

export default function Breadcrumb() {
  const navigate = useNavigate();
  const { department, subcategory } = useBrowseState();

  return (
    <nav id="v129Breadcrumb" aria-label="Shopping path">
      <button type="button" className="crumbShop" onClick={() => navigate(shopPath())}>
        Shop
      </button>
      {department !== "All" && (
        <>
          <span className="crumbSep">›</span>
          <button type="button" onClick={() => navigate(shopPath({ department }))}>
            {department}
          </button>
          {subcategory !== "All" && (
            <>
              <span className="crumbSep">›</span>
              <span className="crumbCurrent">{subcategory === "Kid" ? "Kids" : subcategory}</span>
            </>
          )}
        </>
      )}
    </nav>
  );
}
